import DurationLabel from 'components/DurationLabel';
import { BodyLarge, FlexColMd, FlexMd, Headline2, HorizontalRule } from 'components/Elements';
import { LearnerActivity } from 'models/LearnerCourse';
import ActivityTypeLabel from 'pages/build-course/components/ActivityTypeLabel';

type ActivityHeaderProps = {
    activity: LearnerActivity;
};

export default function ActivityHeader({ activity }: ActivityHeaderProps): JSX.Element {
    return (
        <FlexColMd>
            <Headline2>{activity.title}</Headline2>
            <FlexMd>
                <ActivityTypeLabel activityType={activity.type} buildMethod={activity.buildMethod} />
                {activity.durationInMins ? <DurationLabel durationInMins={activity.durationInMins} hideTitle /> : null}
            </FlexMd>
            {activity.description && <BodyLarge>{activity.description}</BodyLarge>}
            <HorizontalRule />
        </FlexColMd>
    );
}
